<h2>{{'events.add_event'|translate}}</h2>

<div>
  <form>
    <mat-form-field appearance="outline">
      <mat-label position="stacked">{{'events.event'|translate}}</mat-label>
      <input matInput [(ngModel)]="event.title" name="title" placeholder="{{'events.what'|translate}}">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label position="stacked">{{'events.comment'|translate}}</mat-label>
      <input matInput [(ngModel)]="event.comment" name="comment" placeholder="{{'events.your_comment'|translate}}">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{'datatable.zone'|translate}}</mat-label>
      <mat-select [(ngModel)]="event.zones" name="zones">
        <mat-option [value]="zone.id" *ngFor="let zone of zones">{{zone.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="time-select">
      <label position="stacked">
        {{'events.time'|translate}}
      </label>

      <app-range-picker [startDate]="event.startDate" [endDate]="event.endDate" (change)="onPickerChanged($event)">
      </app-range-picker>
    </div>

    <div *ngIf="photos.length!=0">
      <div [style.width]="(100/photos.length) + '%'" *ngFor="let photo of photos">
        <img [src]="photo.data" [ngClass]="{'showed-photo': photos.length==1}" />
      </div>
    </div>

    <p *ngIf="errorPhotos" class="error-photos">
      {{'events.uploaded_error_photos'|translate}}
    </p>

    <button mat-flat-button color="primary" class="btn" (click)="saveEvent()">
      {{'form.save'|translate}}
    </button>

    <button mat-flat-button color="warn" class="btn" (click)="dismiss()">
      {{'form.cancel'|translate}}
    </button>
  </form>
</div>